import { LocalityGrid } from 'generated/graphql';

import { getGridRowsAndCols } from './getGridRowsAndCols';

/** default bardge index is in the middle of the left side of grid */
export function getDefaultBargeIndex(arrangement: LocalityGrid): number {
  const { cols, rows } = getGridRowsAndCols(arrangement);
  return Math.floor(2 * cols + 1.5 * rows) - 1;
}
